import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";
let msalContext = null;

export const getMsalContext = () => {
  if (!msalContext) msalContext = new PublicClientApplication(msalConfig);
  return msalContext;
}

